import { render } from "./crm-activities.vue?vue&type=template&id=12738760&scoped=true"
import script from "./crm-activities.vue?vue&type=script&lang=js"
export * from "./crm-activities.vue?vue&type=script&lang=js"

import "./crm-activities.vue?vue&type=style&index=0&id=12738760&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12738760"]])

export default __exports__